// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__LsuCw","menu":"Nav_menu__zIPZs","link":"Nav_link__lz2mG","button":"Nav_button__icPBY","hidden":"Nav_hidden__wHdL5"};